import { RouteInfo } from './sidebar.metadata';
export const ROUTES: RouteInfo[] = [
  // Admin Modules

  {
    path: '/admin/dashboard/main',
    title: 'MENUITEMS.DASHBOARD.TEXT',
    iconType: 'material-icons-outlined',
    icon: 'space_dashboard',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Admin', 'SchoolDirector'],
    submenu: [],
  },
  {
    path: '/admin/inscriptions',
    title: 'MENUITEMS.INSCRIPTIONS.TEXT',
    iconType: 'material-icons-outlined',
    icon: 'account_balance',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Admin', 'SchoolDirector'],
    submenu: [],
  },
  {
    path: '',
    title: 'MENUITEMS.SCHOOLS.TEXT',
    iconType: 'material-icons-outlined',
    icon: 'domain',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Admin', 'SchoolDirector'],
    submenu: [
      {
        path: '/admin/schools/all-schools',
        title: 'MENUITEMS.SCHOOLS.LIST.ALL-SCHOOLS',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: ['Admin'],
        submenu: [],
      },
      {
        path: '/admin/schools/my-school',
        title: 'MENUITEMS.SCHOOLS.LIST.MY-SCHOOL',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: ['SchoolDirector'],
        submenu: [],
      },
      {
        path: '/admin/schools/levels',
        title: 'MENUITEMS.SCHOOLS.LIST.LEVELS',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: ['Admin', 'SchoolDirector'],
        submenu: [],
      },
      {
        path: '/admin/schools/classes',
        title: 'MENUITEMS.SCHOOLS.LIST.CLASSES',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: ['Admin', 'SchoolDirector'],
        submenu: [],
      },
      {
        path: '/admin/schools/groups',
        title: 'MENUITEMS.SCHOOLS.LIST.GROUPS',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: ['Admin', 'SchoolDirector'],
        submenu: [],
      },
      {
        path: '/admin/schools/directors',
        title: 'MENUITEMS.SCHOOLS.LIST.SCHOOL-DIRECTORS',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: ['Admin'],
        submenu: [],
      },
    ],
  },
  {
    path: '/admin/parents/all-parents',
    title: 'MENUITEMS.PARENTS.TEXT',
    iconType: 'material-icons-outlined',
    icon: 'family_restroom',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Admin', 'SchoolDirector'],
    submenu: [],
  },
  {
    path: '/admin/teachers/all-teachers',
    title: 'MENUITEMS.TEACHERS.TEXT',
    iconType: 'material-icons-outlined',
    icon: 'person',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Admin', 'SchoolDirector'],
    submenu: [],
  },
  {
    path: '/admin/doctors/all-doctors',
    title: 'MENUITEMS.DOCTORS.TEXT',
    iconType: 'material-icons-outlined',
    icon: 'local_hospital',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Admin', 'SchoolDirector'],
    submenu: [],
  },
  {
    path: '/admin/students/all-students',
    title: 'MENUITEMS.STUDENTS.TEXT',
    iconType: 'material-icons-outlined',
    icon: 'people_alt',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Admin', 'SchoolDirector'],
    submenu: [],
  },
  {
    path: '/admin/authorizations',
    title: 'MENUITEMS.AUTHORIZATIONS.TEXT',
    iconType: 'material-icons-outlined',
    icon: 'assignment_turned_in',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Admin', 'SchoolDirector'],
    submenu: [],
  },
  {
    path: '/admin/oversight/journals',
    title: 'MENUITEMS.OVERSIGHT.JOURNALS',
    iconType: 'material-icons-outlined',
    icon: 'menu_book',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Admin', 'SchoolDirector'],
    submenu: [],
  },
  {
    path: '/admin/oversight/attendance',
    title: 'MENUITEMS.OVERSIGHT.ATTENDANCE',
    iconType: 'material-icons-outlined',
    icon: 'fact_check',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Admin', 'SchoolDirector'],
    submenu: [],
  },
  {
    path: '/admin/payments',
    title: 'MENUITEMS.PAYMENTS.TEXT',
    iconType: 'material-icons-outlined',
    icon: 'payments',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Admin', 'SchoolDirector'],
    submenu: [
      {
        path: '/admin/payments',
        title: 'MENUITEMS.PAYMENTS.LIST.GRID',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: ['Admin', 'SchoolDirector'],
        submenu: [],
      },
      {
        path: '/admin/payments/overdue',
        title: 'MENUITEMS.PAYMENTS.LIST.OVERDUE',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: ['Admin', 'SchoolDirector'],
        submenu: [],
      },
      {
        path: '/admin/payments/summary',
        title: 'MENUITEMS.PAYMENTS.LIST.SUMMARY',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: ['Admin', 'SchoolDirector'],
        submenu: [],
      },
      {
        path: '/admin/payments/invoices',
        title: 'MENUITEMS.PAYMENTS.LIST.INVOICES',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: ['Admin', 'SchoolDirector'],
        submenu: [],
      },
      {
        path: '/admin/payments/settings',
        title: 'MENUITEMS.PAYMENTS.LIST.REMINDERS',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: ['Admin', 'SchoolDirector'],
        submenu: [],
      },
    ],
  },
  {
    path: '/admin/documents',
    title: 'MENUITEMS.DOCUMENTS.TEXT',
    iconType: 'material-icons-outlined',
    icon: 'folder_open',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Admin', 'SchoolDirector'],
    submenu: [],
  },
  {
    path: '/admin/hr',
    title: 'MENUITEMS.HR.TEXT',
    iconType: 'material-icons-outlined',
    icon: 'badge',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Admin', 'SchoolDirector'],
    submenu: [],
  },
  {
    path: '/admin/audit',
    title: 'MENUITEMS.AUDIT.TEXT',
    iconType: 'material-icons-outlined',
    icon: 'policy',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Admin', 'SchoolDirector'],
    submenu: [],
  },
  {
    path: '',
    title: 'MENUITEMS.PLANNING.TEXT',
    iconType: 'material-icons-outlined',
    icon: 'event_available',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Admin', 'SchoolDirector'],
    submenu: [
      {
        path: '/admin/planning/educators',
        title: 'MENUITEMS.PLANNING.LIST.EDUCATORS',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: ['Admin', 'SchoolDirector'],
        submenu: [],
      },
      {
        path: '/admin/planning/substitutions',
        title: 'MENUITEMS.PLANNING.LIST.SUBSTITUTIONS',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: ['Admin', 'SchoolDirector'],
        submenu: [],
      },
    ],
  },
  {
    path: '/admin/schedules',
    title: 'MENUITEMS.SCHEDULES.TEXT',
    iconType: 'material-icons-outlined',
    icon: 'calendar_view_week',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Admin', 'SchoolDirector'],
    submenu: [],
  },
  {
    path: '/admin/communications',
    title: 'MENUITEMS.COMMUNICATIONS.TEXT',
    iconType: 'material-icons-outlined',
    icon: 'campaign',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Admin', 'SchoolDirector'],
    submenu: [],
  },
  {
    path: '',
    title: 'MENUITEMS.TRANSPORT.TEXT',
    iconType: 'material-icons-outlined',
    icon: 'directions_bus',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Admin', 'SchoolDirector'],
    submenu: [
      {
        path: '/admin/transport/routes',
        title: 'MENUITEMS.TRANSPORT.LIST.ROUTES',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: ['Admin', 'SchoolDirector'],
        submenu: [],
      },
      {
        path: '/admin/transport/assignments',
        title: 'MENUITEMS.TRANSPORT.LIST.ASSIGNMENTS',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: ['Admin', 'SchoolDirector'],
        submenu: [],
      },
      {
        path: '/admin/transport/live',
        title: 'MENUITEMS.TRANSPORT.LIST.LIVE',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: ['Admin', 'SchoolDirector'],
        submenu: [],
      },
    ],
  },
  {
    path: '',
    title: 'MENUITEMS.CANTEEN.TEXT',
    iconType: 'material-icons-outlined',
    icon: 'restaurant',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Admin', 'SchoolDirector'],
    submenu: [
      {
        path: '/admin/canteen/menus',
        title: 'MENUITEMS.CANTEEN.LIST.MENUS',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: ['Admin', 'SchoolDirector'],
        submenu: [],
      },
      {
        path: '/admin/canteen/dietary',
        title: 'MENUITEMS.CANTEEN.LIST.DIETARY',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: ['Admin', 'SchoolDirector'],
        submenu: [],
      },
      {
        path: '/admin/canteen/kitchen',
        title: 'MENUITEMS.CANTEEN.LIST.KITCHEN',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: ['Admin', 'SchoolDirector'],
        submenu: [],
      },
    ],
  },
  {
    path: '/admin/platform/subscriptions',
    title: 'MENUITEMS.SUBSCRIPTIONS.TEXT',
    iconType: 'material-icons-outlined',
    icon: 'cloud',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Admin'],
    submenu: [],
  },

  {
    path: '',
    title: 'MENUITEMS.ATTENDANCE.TEXT',
    iconType: 'material-icons-outlined',
    icon: 'history_edu',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Admin'],
    submenu: [
      {
        path: '/admin/attendance/staff',
        title: 'MENUITEMS.ATTENDANCE.LIST.STAFF',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: ['Admin'],
        submenu: [],
      },
      {
        path: '/admin/attendance/details',
        title: 'MENUITEMS.ATTENDANCE.LIST.DETAILS',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: ['Admin'],
        submenu: [],
      },
      {
        path: '/admin/attendance/attendance-sheet',
        title: 'MENUITEMS.ATTENDANCE.LIST.SHEET',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: ['Admin'],
        submenu: [],
      },
    ],
  },

  // Teacher Modules

  {
    path: '/teacher/dashboard',
    title: 'MENUITEMS.TEACHER.LIST.DASHBOARD',
    iconType: 'material-icons-outlined',
    icon: 'dashboard',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Teacher'],
    submenu: [],
  },
  {
    path: '/teacher/attendance',
    title: 'MENUITEMS.TEACHER.LIST.ATTENDANCE',
    iconType: 'material-icons-outlined',
    icon: 'how_to_reg',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Teacher'],
    submenu: [],
  },
  {
    path: '/teacher/journal',
    title: 'MENUITEMS.TEACHER.LIST.JOURNAL',
    iconType: 'material-icons-outlined',
    icon: 'auto_stories',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Teacher'],
    submenu: [],
  },
  {
    path: '/teacher/messages',
    title: 'MENUITEMS.TEACHER.LIST.MESSAGES',
    iconType: 'material-icons-outlined',
    icon: 'chat',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Teacher'],
    submenu: [],
  },
  {
    path: '/teacher/incidents',
    title: 'MENUITEMS.TEACHER.LIST.INCIDENTS',
    iconType: 'material-icons-outlined',
    icon: 'report_problem',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Teacher'],
    submenu: [],
  },
  {
    path: '/teacher/health-tracking',
    title: 'MENUITEMS.TEACHER.LIST.HEALTH',
    iconType: 'material-icons-outlined',
    icon: 'monitor_heart',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Teacher'],
    submenu: [],
  },
  {
    path: '/teacher/medications',
    title: 'MENUITEMS.TEACHER.LIST.MEDICATIONS',
    iconType: 'material-icons-outlined',
    icon: 'medication',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Teacher'],
    submenu: [],
  },
  {
    path: '/teacher/schedule',
    title: 'MENUITEMS.TEACHER.LIST.SCHEDULE',
    iconType: 'material-icons-outlined',
    icon: 'calendar_view_week',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Teacher'],
    submenu: [],
  },
  {
    path: '/teacher/transport',
    title: 'MENUITEMS.TEACHER.LIST.TRANSPORT',
    iconType: 'material-icons-outlined',
    icon: 'directions_bus',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Teacher'],
    submenu: [],
  },
  {
    path: '/teacher/canteen',
    title: 'MENUITEMS.TEACHER.LIST.CANTEEN',
    iconType: 'material-icons-outlined',
    icon: 'restaurant',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Teacher'],
    submenu: [],
  },
  {
    path: '/teacher/staff-clock',
    title: 'MENUITEMS.TEACHER.LIST.CLOCK',
    iconType: 'material-icons-outlined',
    icon: 'schedule',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Teacher'],
    submenu: [],
  },

  // Parent Modules

  // Doctor Modules

  {
    path: '/doctor/dashboard',
    title: 'MENUITEMS.DOCTOR_SPACE.DASHBOARD',
    iconType: 'material-icons-outlined',
    icon: 'dashboard',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Doctor'],
    submenu: [],
  },
  {
    path: '/doctor/children',
    title: 'MENUITEMS.DOCTOR_SPACE.CHILDREN',
    iconType: 'material-icons-outlined',
    icon: 'child_care',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Doctor'],
    submenu: [],
  },
  {
    path: '/doctor/reports',
    title: 'MENUITEMS.DOCTOR_SPACE.REPORTS',
    iconType: 'material-icons-outlined',
    icon: 'assessment',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Doctor'],
    submenu: [],
  },
  {
    path: '/doctor/prescriptions',
    title: 'MENUITEMS.DOCTOR_SPACE.PRESCRIPTIONS',
    iconType: 'material-icons-outlined',
    icon: 'medication',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Doctor'],
    submenu: [],
  },

  // Parent Modules

  {
    path: '/parent/dashboard',
    title: 'MENUITEMS.PARENT_SPACE.DASHBOARD',
    iconType: 'material-icons-outlined',
    icon: 'dashboard',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Parent'],
    submenu: [],
  },
  {
    path: '/parent/medical-report',
    title: 'MENUITEMS.PARENT_SPACE.MEDICAL',
    iconType: 'material-icons-outlined',
    icon: 'medical_information',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Parent'],
    submenu: [],
  },
  {
    path: '/parent/journal',
    title: 'MENUITEMS.PARENT_SPACE.JOURNAL',
    iconType: 'material-icons-outlined',
    icon: 'auto_stories',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Parent'],
    submenu: [],
  },
  {
    path: '/parent/timeline',
    title: 'MENUITEMS.PARENT_SPACE.TIMELINE',
    iconType: 'material-icons-outlined',
    icon: 'timeline',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Parent'],
    submenu: [],
  },
  {
    path: '/parent/media',
    title: 'MENUITEMS.PARENT_SPACE.MEDIA',
    iconType: 'material-icons-outlined',
    icon: 'perm_media',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Parent'],
    submenu: [],
  },
  {
    path: '/parent/documents',
    title: 'MENUITEMS.PARENT_SPACE.DOCUMENTS',
    iconType: 'material-icons-outlined',
    icon: 'description',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Parent'],
    submenu: [],
  },
  {
    path: '/parent/messages',
    title: 'MENUITEMS.PARENT_SPACE.MESSAGES',
    iconType: 'material-icons-outlined',
    icon: 'chat',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Parent'],
    submenu: [],
  },
  {
    path: '/parent/payments',
    title: 'MENUITEMS.PARENT_SPACE.PAYMENTS',
    iconType: 'material-icons-outlined',
    icon: 'payments',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Parent'],
    submenu: [],
  },
  {
    path: '/parent/transport',
    title: 'MENUITEMS.PARENT_SPACE.TRANSPORT',
    iconType: 'material-icons-outlined',
    icon: 'directions_bus',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Parent'],
    submenu: [],
  },
  {
    path: '/parent/canteen',
    title: 'MENUITEMS.PARENT_SPACE.CANTEEN',
    iconType: 'material-icons-outlined',
    icon: 'restaurant',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Parent'],
    submenu: [],
  },
  {
    path: '/parent/authorizations',
    title: 'MENUITEMS.PARENT_SPACE.AUTHORIZATIONS',
    iconType: 'material-icons-outlined',
    icon: 'assignment_turned_in',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Parent'],
    submenu: [],
  },
  {
    path: '/parent/profile',
    title: 'MENUITEMS.PARENT_SPACE.PROFILE',
    iconType: 'material-icons-outlined',
    icon: 'person',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Parent'],
    submenu: [],
  },


  // Common Module

  {
    path: 'calendar',
    title: 'MENUITEMS.EVENTS.TEXT',
    iconType: 'material-icons-outlined',
    icon: 'event_note',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Admin'],
    submenu: [],
  },
];
